import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ViewMaterialsComponent } from './view-materials/view-materials.component';
import { ViewDetailedMaterialComponent } from './view-detailed-material/view-detailed-material.component';
import { EditMaterialComponent } from './edit-material/edit-material.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'view-materials', pathMatch: 'full' },
      { path: 'view-materials', component: ViewMaterialsComponent},
      { path: 'detailed-view/:id', pathMatch: 'full', component: ViewDetailedMaterialComponent },
      { path: 'edit-material/:materialId', pathMatch: 'full', component: EditMaterialComponent }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})

export class SosMaterialsRoutingModule { }

export const materialComponents = [
  ViewMaterialsComponent,
  ViewDetailedMaterialComponent,
  EditMaterialComponent
];